export default __webpack_public_path__ + "static/media/ai-in-banking-and-insurance-use-cases.4a8b68f7.jpeg";